module.exports = __webpack_public_path__ + "static/media/Admin-15.4e891892.png";